module.exports = __webpack_public_path__ + "img/what-happens-mobile-fr@2x.b9cccb3d.webp";